import React, { useContext, useMemo, useState } from 'react'
import { useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { addLocale } from 'primereact/api';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import PropTypes, { element } from 'prop-types'
import { DataTable } from 'primereact/datatable';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import dateFormat from '../../services/DateFormat.service';
import apis from '../../api';
import { useRef } from 'react';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import useWindowDimensions from '../hooks/useDimensions';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toolbar as BigToolbar } from 'react-big-calendar/lib/Toolbar';
import InfoIcon from '../InfoIcon/InfoIcon';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './Week.css'
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';

const Week = () => {

    const [fechaInicio, setFechaInicio] = useState(new Date(Date.now()))
    const [fechaInicioCalendario, setFechaInicioCalendario] = useState(new Date(Date.now()))
    const [novedadesCalendario, setNovedadesCalendario] = useState([])
    const [novedades, setNovedades] = useState([])
    const [turnos, setTurnos] = useState([])
    const [listaTurnos, setListaTurnos] = useState([])
    const [semanas, setSemanas] = useState([])
    const [contratos, setContratos] = useState()
    const { width, height } = useWindowDimensions()

    const [turno, setTurno] = useState({})
    const [semana, setSemana] = useState({
        WEEK: "",
        INIT_DT_WEEK: "",
        END_DT_WEEK: "",
        index: ""
    })
    const [rowsTurno, setRowsTurno] = useState([])
    const [nombre, setNombre] = useState("")
    const [fechas, setFechas] = useState("")
    const [shifts, setShifts] = useState("")
    const [year, setYear] = useState("")

    const [days, setDays] = useState({
        Lunes: "",
        Martes: "",
        "Miércoles": "",
        Jueves: "",
        Viernes: "",
        "Sábado": "",
        Domingo: ""
    })

    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [consultado, setConsultado] = useState(0)
    const [loadPage, setLoadPage] = useState(false)

    const [isOpenAgregar, setIsOpenAgregar] = useState(false)
    const [isOpenVer, setIsOpenVer] = useState(false)
    const [isOpenEliminar, setIsOpenEliminar] = useState(false)

    const toast = useRef(null);
    const elementWidth = { width: "12rem" }
    const headers = {
        authorization: localStorage.getItem('token')
    }

    let sixDate = new Date(Date.now())
    sixDate.setMonth(sixDate.getMonth() - 12)
    let initDate = new Date('2022-07-13')

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    const labelStyle = {
        // display: "block",
        // float: "left",
        marginTop: "5px",
        // width: "100%",
        paddingTop: "5px",
        // marginLeft: '-3rem'
    }

    /*Propiedades de la tabla del componente*/
    const [rowData, setRowData] = useState([]);
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [selectedRows, setSelectedRows] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [registros, setRegistros] = useState([]);

    useEffect(() => {
        shiftsLists("")
    }, [])

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
                    <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
                </span>
            </div>
        )
    }

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'JOB_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'DAY_CSO': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    const header1 = renderHeader1();

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    const setTable = async (week, year = "") => {
        setLoadPage(false)
        console.log(week)
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _contract = localStorage.getItem('contract_id')

        try {
            await apis.getShifts(_entity, _client, _contract, year, week.INIT_DT_WEEK, week.END_DT_WEEK, headers).then(res => {
                let _turnos = res.data.SHEDULES
                console.log(_turnos)
                setTurnos(_turnos)
                let turnosActivos = _turnos.filter(turno => turno.YEAR === fechaInicioCalendario.getFullYear().toString())[0]?.WEEKS
                console.log(turnosActivos)
                console.log(semana)
                let turnosSemana = turnosActivos.filter(turno => turno.WEEK === week.WEEK)
                if (turnosSemana.length > 0) {
                    console.log(turnosSemana)
                    setShifts(turnosSemana[0].CONTRACTS)
                }
                else {
                    setShifts([])
                }
                setLoading1(false)
                setLoadPage(true)
            })
        }
        catch (err) {
            console.log(err)
            setLoadPage(true)
            setLoading1(false)
        }
    }

    const shiftsLists = async (_year = "") => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _contract = localStorage.getItem('contract_id')

        try {
            await apis.getShiftsLists(_entity, _client, _contract, _year, headers).then(res => {
                console.log(res.data)
                let contracts = res.data.CONTRACTS
                contracts = contracts.filter(c => c.CONTRACT_ID === localStorage.getItem('contract_id'))
                setRows(contracts)
                setContratos(contracts)
                let _turnos = res.data.SHIFTS
                console.log(_turnos)
                let newTurnos = []
                _turnos.forEach(t => {
                    let newTurno = {
                        ...t,
                        LABEL: `${t.NAME} (${t.SCHEDULE}) (${t.SCHEDULE})`
                    }
                    newTurnos.push(newTurno)
                })
                let newYear = res.data.WEEKS[1].YEAR
                let yearDate = newYear < year ? res.data.WEEKS[1].END_DT_WEEK.split('-') : res.data.WEEKS[1].INIT_DT_WEEK.split('-')
                setYear(newYear)
                yearDate = yearDate[2] + "-" + yearDate[1] + '-' + yearDate[0]
                let currentDate = _year !== "" ? yearDate : new Date().toDateString()
                currentDate = Date.parse(currentDate)
                console.log(res.data.WEEKS[1].WEEKS)
                let currentWeek = res.data.WEEKS[1].WEEKS.filter(week => {
                    let splitDateInit = week.INIT_DT_WEEK.split('-')
                    let splitDateEnd = week.END_DT_WEEK.split('-')
                    let _dateInit = splitDateInit[2] + '-' + splitDateInit[1] + '-' + splitDateInit[0]
                    let _dateEnd = splitDateEnd[2] + '-' + splitDateEnd[1] + '-' + splitDateEnd[0]
                    console.log("Comparación antes: ", currentDate, _dateInit, _dateEnd)
                    _dateInit = Date.parse(_dateInit)
                    _dateEnd = Date.parse(_dateEnd)
                    console.log("Comparación: ", currentDate, _dateInit, _dateEnd)
                    if (currentDate >= _dateInit && currentDate <= _dateEnd) {
                        console.log("Semana encontrada: ", week)
                        return week
                    }
                })
                console.log(currentWeek)
                let _semana = {
                    ...currentWeek[0],
                    index: (parseInt(currentWeek[0].WEEK) - 1).toString()
                }
                console.log(_semana)
                setSemana({
                    ..._semana
                })
                setListaTurnos(newTurnos)
                setSemanas(res.data.WEEKS[1].WEEKS)
                setNovedadesCalendario([])
                setTable(_semana, newYear)
            })
        }
        catch (err) {
            console.log(err)
            setLoadPage(true)
            setLoading1(false)
        }
    }

    const addShift = async () => {
        let dates = []
        for (const [key, value] of Object.entries(days)) {
            if (value !== "") {
                dates.push(value)
            }
        }

        let payload = {
            ENTITY: localStorage.getItem('entity'),
            CLIENT: localStorage.getItem('client'),
            CONTRACT_ID: turno.CONTRACT_ID,
            DATE_SHEDULE: dates,
            SHIFTS_ID: turno.ID
        }
        try {
            await apis.postShift(payload, headers).then(res => {
                console.log(res.data.SHEDULES[0])
                setTable(semana, year)
                setLoading1(false)
                setIsOpenAgregar(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: `Turno creado exitosamente` });
            })
        }
        catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const removeShift = async () => {
        let shift_id = rowsTurno[0].PROGRAM_SHIFTS_ID
        try {
            await apis.deleteShift(localStorage.getItem('entity'), localStorage.getItem('client'), shift_id, headers).then(res => {
                setTable(semana, year)
                setLoading2(false)
                setIsOpenVer(false)
                setIsOpenEliminar(false)
                toast.current.show({ severity: 'info', summary: 'Éxito', detail: `Turno ${shift_id} eliminado exitosamente` });
            })
        }
        catch (err) {
            setLoading2(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const onChange = (e) => {
        setRegistros(e.value)
        let news = []
        e.value.forEach(element => {
            let nov = novedades.filter((n) => n.CONTRACT_ID === element.CONTRACT_ID)
            nov.forEach(newNov => {
                news.push(newNov)
            })
        })
        setNovedadesCalendario(news)
    }

    // const rightToolbarTemplate = () => {
    //     return (
    //         <React.Fragment>
    //             <Button loading={loading1} label="Consultar" icon="pi pi-search" tooltip="Actualizar según la fecha seleccionada"
    //                 className=" mr-2 p-button-sm" onClick={() => { setLoading1(true); tableNov(); }} tooltipOptions={{ position: 'top' }} />
    //         </React.Fragment>
    //     )
    // }


    const leftToolbarTemplate = () => {
        return (
            <div>
                <label style={labelStyle}>Seleccione un año</label>
                &nbsp;
                <Calendar id="navigators" value={fechaInicio}
                    onChange={(e) => {
                        setFechaInicio(e.value);
                        setLoadPage(false)
                        shiftsLists(e.value.getFullYear().toString())
                    }}
                    locale="es" dateFormat="yy" view='year' yearRange="1900:2150" showIcon style={elementWidth}
                    placeholder="Seleccione un mes"
                />
            </div>
        )
    }

    const changeWeek = (value) => {

        // let currentYear = fechaInicio.getFullYear();
        let currentYear = parseInt(semana.END_DT_WEEK.split('-')[2]);
        let newWeek = value;
        let newYear = currentYear;
        let isYearChanged = false;

        if (value === 0) {
            newWeek = 52;
            newYear = currentYear - 1;
            isYearChanged = true;
        } else if (value > 52) {
            newWeek = 1;
            newYear = currentYear + 1;
            isYearChanged = true;
        }

        console.log("Year:", newYear, "Week:", newWeek);

        if (isYearChanged) {
            setLoadPage(false)
            setFechaInicio(new Date(newYear, 0, 1));
            shiftsLists(newYear.toString());
        }

        else {

            let newIndex = newWeek - 1;
            let updatedWeek = semanas[newIndex];

            // if (turnos.length > 0) {
            //     let newTurnos = turnos.filter(turno => newYear.toString() === turno.YEAR.toString());
            //     let turnosSemana = newTurnos.length > 0
            //         ? newTurnos[0].WEEKS.filter(turno => newWeek.toString() === turno.WEEK)
            //         : [];

            //     if (turnosSemana.length > 0) {
            //         setShifts(turnosSemana[0].CONTRACTS);
            //     }
            //     else {
            //         setShifts([]);
            //     }
            // }
            // else {
            //     setShifts([]);
            // }

            setTable(updatedWeek, newYear)

            setSemana({
                ...semana,
                ...updatedWeek,
                index: newIndex,
            });
        }
    };

    const weekOptionTemplate = (option) => {
        return (
            <div className="flex align-items-start justify-content-start text-left" style={{ width: '6rem' }}>
                {option.WEEK}
            </div>
        );
    };

    const rightElements = [
        <Button icon='pi pi-angle-double-left' rounded text onClick={() => changeWeek(parseInt(semana.WEEK) - 1)} />,
        <label className='flex align-self-center'>Semana</label>,
        <Dropdown options={semanas} value={semana} optionLabel='WEEK' placeholder={semana ? semana.WEEK : ""} style={{ width: '6rem' }}
            filter filterBy='WEEK'
            onChange={(e) => changeWeek(parseInt(e.value.WEEK))}
            itemTemplate={weekOptionTemplate}
            className='select'
        />,
        <label className='flex align-self-center'>{semana.INIT_DT_WEEK} a {semana.END_DT_WEEK}</label>,
        <Button icon='pi pi-angle-double-right' rounded text onClick={() => changeWeek(parseInt(semana.WEEK) + 1)} />,
    ]

    const rightToolbarTemplate = () => {
        return (
            <div className='left-tb flex align-content-center gap-3'>
                {width > 768 ?
                    rightElements.map(element => {
                        return element
                    })
                    :
                    <div className='flex flex-column align-content-center gap-2 mt-2'>
                        {rightElements[1]}
                        <div className='flex flex-row'>
                            {rightElements[0]}
                            {rightElements[2]}
                            {rightElements[4]}
                        </div>
                        {rightElements[3]}
                    </div>
                }
            </div>
        )
    }

    const photoBodyTemplate = (rowData) => {
        const photo = rowData.IMAGES ? rowData.IMAGES : process.env.REACT_APP_PROFILE_PIC;
        let dates = ""
        for (const [key, value] of Object.entries(days)) {
            if (value !== "") {
                dates += `${key}; `
            }
        }
        setFechas(dates)
        return (
            <div className='flex flex-row align-items-center justify-content-start gap-2'>
                <img alt={""} loading='eager' src={photo} width={50} height={50} style={{ verticalAlign: 'middle', borderRadius: '40px' }} />
                <div className='flex flex-column ml-2'>
                    <span className='font-bold'>{rowData.NAME}</span>
                    <span>{rowData.CONTRACT_ID} - {rowData.JOB_ID}</span>
                </div>
            </div>
        );
    }

    const calculateDate = (date, days = 0) => {
        let splitDate = date.split('-')
        let _date = splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0]
        let newDate = new Date(_date)
        newDate.setDate(newDate.getDate() + days + 1)
        newDate = newDate.toLocaleDateString("es-CL")
        return newDate
    }

    const daysTemplate = (rowData, date, days = 0) => {
        let newDate = calculateDate(date, days)
        let cellData = []
        let newCellData = []
        if (shifts) {
            cellData = shifts.filter((contract) => contract.CONTRACT_ID === rowData.CONTRACT_ID)
            if (cellData.length > 0) {
                newCellData = cellData[0].SCHEDULES.filter((t) => t.DATE_SHEDULE === newDate)
            }
        }
        return (
            <div className='flex align-content-start flex-column gap-2'>
                {
                    newCellData.length > 0 && newCellData.map(cell => {
                        let turnInfo = cell.START_TIME + ' - ' + cell.END_TIME
                        console.log(cell)
                        return (
                            <span onClick={() => { setRowsTurno([cell]); setIsOpenVer(true); }}><Tag icon='pi pi-clock' value={turnInfo} style={{ height: '2rem', width: '8rem' }} rounded severity='info' /></span>
                        )
                    })
                }
            </div>
        )
    }

    const headerTemplate = (day, date) => {
        return (
            <div className='flex gap-1'>
                <span>{day}</span>
                <Checkbox
                    disabled={contratos.length === 0}
                    inputId="binary"
                    checked={days[day] !== ""}
                    onChange={() => {
                        setDays({
                            ...days,
                            [day]: days[day] === "" ? date : ""
                        })
                    }}
                />
            </div>
        )
    }

    const addFooter = (
        <div>
            <Button onClick={() => setIsOpenAgregar(false)}>Cancelar</Button>
            <Button onClick={() => { setLoading1(true); addShift() }} loading={loading1} label='Guardar'></Button>
        </div>
    );

    const addHeader = (
        <div>
            <h3>Agregar turno</h3>
        </div>
    );

    const infoFooter = (
        <div>
            <Button onClick={() => setIsOpenVer(false)} label='Cerrar'></Button>
            {/* <Button onClick={() => setIsOpenEliminar(true)} loading={loading1} label='Eliminar'></Button> */}
        </div>
    );

    const infoHeader = (
        <div>
            <h3>Detalles turno</h3>
        </div>
    );

    const deleteFooter = (
        <div>
            <Button onClick={() => setIsOpenEliminar(false)} label='Cancelar'></Button>
            <Button onClick={() => { setLoading2(true); removeShift() }} loading={loading2} label='Eliminar'></Button>
        </div>
    );

    const deleteHeader = (
        <div>
            <h3>¿Desea eliminar el turno?</h3>
        </div>
    );

    const optionTemplate = (option) => {
        return (
            <div className="flex align-items-start justify-content-start text-left" style={{ whiteSpace: 'pre-line', width: '20rem' }}>
                {option.LABEL}
            </div>
        );
    };

    return (
        <div className='surface-100 px-4 py-5 md:px-6 lg:px-8r'>
            <Dialog header={addHeader} footer={addFooter} visible={isOpenAgregar} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={() => setIsOpenAgregar(false)}>
                <div className='flex flex-column'>
                    <label style={labelStyle}>Empleado</label>
                    <InputText value={nombre} disabled />
                    <label style={labelStyle}>Días</label>
                    <InputText value={fechas} disabled />
                    <label style={labelStyle}>Semana</label>
                    <InputText value={semana.WEEK + ": " + semana.INIT_DT_WEEK + ' a ' + semana.END_DT_WEEK} disabled />
                    <label style={labelStyle}>Turno</label>
                    <Dropdown options={listaTurnos} optionLabel='LABEL' value={turno} onChange={(e) => setTurno({ ...turno, ...e.value })}
                        autofocus filter showClear filterBy="LABEL" emptyMessage={"No hay turnos disponibles"}
                        placeholder={turno ? turno.LABEL : 'Seleccione'} itemTemplate={optionTemplate}
                    />
                </div>
            </Dialog>
            {rowsTurno.length > 0 && <Dialog header={infoHeader} footer={infoFooter} visible={isOpenVer} position="top" style={{ width: width > 768 ? "32rem" : "100%"}} draggable={false} resizable={false} modal onHide={() => setIsOpenVer(false)}>
                <span style={{ marginBottom: '5rem' }}><span style={{ fontWeight: 'bold' }}>Turno: </span>{rowsTurno[0].SHIFTS_ID}</span><br />
                <span style={{ marginBottom: '5rem' }}><span style={{ fontWeight: 'bold' }}>Fecha: </span>{rowsTurno[0].DATE_SHEDULE}</span>
                <DataTable className="text-xs" value={rowsTurno} scrollable scrollDirection='horizontal'
                    dataKey="CONTRACT_ID" size="small" style={{ width: '100%', marginTop: '2rem' }}>
                    <Column field="START_TIME_REAL" header="Hora inicio"></Column>
                    <Column field="END_TIME_REAL" header="Hora fin"></Column>
                    <Column field="RDF" header="RDF"></Column>
                    <Column field="RN" header="RN"></Column>
                    <Column field="HED" header="HED"></Column>
                    <Column field="HEDF" header="HEDF"></Column>
                    <Column field="HEN" header="HEN"></Column>
                    <Column field="HENF" header="HENF"></Column>
                    <Column field="TOTAL_RN" header="Total RN"></Column>
                    <Column field="TOTAL_HE" header="Total HE"></Column>
                </DataTable>
            </Dialog>}
            <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={() => setIsOpenEliminar(false)} />
            <Toast ref={toast} />
            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
                <span className="text-900">Mi semana</span>
            </div>
            <div className='mt-6 w-full'>
                <SkeletonTable load={loadPage}>
                    <Toolbar className='card week flex flex-row' start={leftToolbarTemplate} end={rightToolbarTemplate} />
                    <div className="card thing">
                        <Tooltip target=".info" className='indigo-tooltip ml-1' />
                        <DataTable className="text-xs" value={rows} first={first2} rows={rows2} scrollable scrollDirection='horizontal'
                            selectionMode="multiple" selection={registros} onSelectionChange={(e) => onChange(e)} dataKey="CONTRACT_ID"
                            size="small" style={{ width: '100%' }}>
                            <Column header="Empleado" body={photoBodyTemplate} style={{ width: '20rem' }}></Column>
                            <Column field="Lunes" body={(data) => daysTemplate(data, semana.INIT_DT_WEEK)} header={() => headerTemplate("Lunes", calculateDate(semana.INIT_DT_WEEK))}></Column>
                            <Column field="Martes" body={(data) => daysTemplate(data, semana.INIT_DT_WEEK, 1)} header={() => headerTemplate("Martes", calculateDate(semana.INIT_DT_WEEK, 1))}></Column>
                            <Column ield="Miercóles" body={(data) => daysTemplate(data, semana.INIT_DT_WEEK, 2)} header={() => headerTemplate("Miércoles", calculateDate(semana.INIT_DT_WEEK, 2))}></Column>
                            <Column field="Jueves" body={(data) => daysTemplate(data, semana.INIT_DT_WEEK, 3)} header={() => headerTemplate("Jueves", calculateDate(semana.INIT_DT_WEEK, 3))}></Column>
                            <Column field="Viernes" body={(data) => daysTemplate(data, semana.INIT_DT_WEEK, 4)} header={() => headerTemplate("Viernes", calculateDate(semana.INIT_DT_WEEK, 4))}></Column>
                            <Column field="Sábado" body={(data) => daysTemplate(data, semana.INIT_DT_WEEK, 5)} header={() => headerTemplate("Sábado", calculateDate(semana.INIT_DT_WEEK, 1))}></Column>
                            <Column field="Domingo" body={(data) => daysTemplate(data, semana.END_DT_WEEK)} header={() => headerTemplate("Domingo", calculateDate(semana.END_DT_WEEK))}></Column>
                        </DataTable>
                    </div>
                </SkeletonTable>
            </div>
        </div>
    )

}

export default Week